import DataService from '@/service/DataService'


const state =  {
  status: {},
  kontakte: []
}

const getters = {
  kontakteStatus: (state) => state.status,
  kontakte: (state) => state.kontakte
};

const actions = {
  // GET
  getBenutzerKontakte({ commit }) {
    commit('GETBENUTZERKONTAKTEREQUEST')

    return DataService.getUserContacts()
      .then(res => {
        commit('GETBENUTZERKONTAKTESUCCESS', res.data)
      })
      .catch(err => {
        if (err.response.status == 404) {
          commit('GETBENUTZERKONTAKTEFAILURE', err.response.data)
        } else {
          commit('GETBENUTZERKONTAKTEFAILURE', "Es ist ein unerwarter Fehler aufgetreten, bitte versuche es später noch ein mal.")
        }
      }) 
  },

  // POST
  createKontakt ({ commit }, kontakt) {
    commit('CREATEKONTAKTREQUEST')

    kontakt.favorit = kontakt.favorit == "1" ? 1 : 0

    return DataService.createContact(kontakt)
      .then(res => {
        commit('CREATEKONTAKTSUCCESS', res.data)
      }).catch(() => {
        commit('CREATEKONTAKTFAILURE', "Es ist ein unerwarter Fehler aufgetreten, bitte versuche es später noch ein mal.")
      })
  },
  uploadKontaktBild ({ commit }, data) {
    commit('UPLOADKONTAKTBILDREQUEST')

    return DataService.uploadContactImage(data.kontaktId, data.file)
      .then(res => {
        commit('UPLOADKONTAKTBILDSUCCESS', res.data)
      })
      .catch(() => {
        commit('UPLOADKONTAKTBILDFAILURE', "Es ist ein unerwarter Fehler aufgetreten, bitte versuche es später noch ein mal.")
      })
  },

  // PUT
  updateKontakt ({ commit }, kontakt) {
    commit('UPDATEKONTAKTREQUEST')

    kontakt.favorit = kontakt.favorit == "1" ? 1 : 0

    return DataService.updateContact(kontakt)
      .then(res => {
        commit('UPDATEKONTAKTSUCCESS', res.data)
      })
      .catch(() => {
        commit('UPDATEKONTAKTFAILURE', "Es ist ein unerwarter Fehler aufgetreten, bitte versuche es später noch ein mal.")
      })
  },

  // DELETE
  deleteKontakt ({ commit }, kontaktId) {
    commit('DELETEKONTAKTREQUEST')

    return DataService.deleteContact(kontaktId)
      .then(() => {
        commit('DELETEKONTAKTSUCCESS', kontaktId)
      })
      .catch(() => {
        commit('DELETEKONTAKTFAILURE', "Es ist ein unerwarter Fehler aufgetreten, bitte versuche es später noch ein mal.")
      })
  }
};

const mutations = {
  // GET
  GETBENUTZERKONTAKTEREQUEST: (state) => {state.status = { getBenutzerKontakte: true }},
  GETBENUTZERKONTAKTESUCCESS: (state, res) => {
    state.status = {}
    state.kontakte = res
  },
  GETBENUTZERKONTAKTEFAILURE: (state, err) => {state.status = {errMsg: err}},

  // POST
  CREATEKONTAKTREQUEST: (state) => {state.status = { creatingContact: true }},
  CREATEKONTAKTSUCCESS: (state, res) => {
    state.status = {}
    state.kontakte.push(res)
  },
  CREATEKONTAKTFAILURE: (state, err) => {state.status = {errMsg: err}},
  UPLOADKONTAKTBILDREQUEST: (state) => {state.status = {uploadingContactImage: true}},
  UPLOADKONTAKTBILDSUCCESS: (state, res) => {
    state.status = {}
    let element = state.kontakte.findIndex(el => el.id === res.id)
    state.kontakte.splice(element, 1, res)
  },
  UPLOADKONTAKTBILDFAILURE: (state, err) => {state.status = {errMsg: err}},

  // PUT
  UPDATEKONTAKTREQUEST: (state) => {state.status = { updatingContact: true }},
  UPDATEKONTAKTSUCCESS: (state, res) => {
    state.status = {}
    let element = state.kontakte.findIndex(el => el.id === res.id)
    state.kontakte.splice(element, 1, res)
  },
  UPDATEKONTAKTFAILURE: (state, err) => {state.status = { errMsg: err }},

  // DELETE
  DELETEKONTAKTREQUEST: (state) => {state.status = { deletingContact: true }},
  DELETEKONTAKTSUCCESS: (state, kontaktId) => {
    state.status = {}
    let element = state.kontakte.findIndex(el => el.id === kontaktId)
    state.kontakte.splice(element, 1)
  },
  DELETEKONTAKTFAILURE: (state, err) => {state.status = { errMsg: err }}
};

export default {
  state,
  getters,
  actions,
  mutations
}